import r from"./setGrabCursor.js";import s from"./unsetGrabCursor.js";const o={setGrabCursor:r,unsetGrabCursor:s};export{o as default};
//# sourceMappingURL=index.js.map
